import { useState, useEffect, useRef, useContext } from 'react';
import { Collapse } from 'bootstrap';
import SelectedUpsells from '../shared/SelectedUpsells';
import { CartContext } from '../../store/CartContext';
import UpsellGroups from './UpsellGroups';
import UpsellProctor from './UpsellProctor';

// ESlint complains about prop-types, you need to define it
import PropTypes from 'prop-types';
UpsellDisplay.propTypes = {
  isSingle: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired,
};

export default function UpsellDisplay({ isSingle, item }) {
  const [cartState, cartDispatch] = useContext(CartContext);

  const [isUpsellCollapsed, setIsUpsellCollapsed] = useState(true);
  const [collapse, setCollapse] = useState(null);

  const upsellCollapse = useRef();

  // checking if any of the upsells is selected
  const isAnUpsellSelected = item.upSellProducts.length ? item.upSellProducts.some((upsell) => upsell.isSelected) : true;

  useEffect(() => {
    setCollapse(
      new Collapse(upsellCollapse.current, {
        toggle: false,
      })
    );

    // using 'show.bs.collapse' because the effect is immediate
    upsellCollapse.current.addEventListener('show.bs.collapse', () => {
      setIsUpsellCollapsed(false);
    });
    // using 'hidden.bs.collapse' because the effect is after it collapses
    upsellCollapse.current.addEventListener('hidden.bs.collapse', () => {
      setIsUpsellCollapsed(true);
    });
  }, []);

  useEffect(() => {
    if (!isSingle || isAnUpsellSelected) {
      cartDispatch({
        type: 'EXPERIENCE',
        payload: {
          viewedUpsells: true,
        },
      });
    }
  }, [cartDispatch, isSingle, isAnUpsellSelected]);

  const toggleCollapse = () => {
    collapse.toggle();

    // track clicked state
    if (!cartState.userExperience.viewedUpsells) {
      cartDispatch({
        type: 'EXPERIENCE',
        payload: {
          viewedUpsells: true,
        },
      });
    }
  };

  const isUpsellOnlyProctor =
    item.upSellProducts.length > 0 && item.upSellProducts.every((upsell) => upsell.upsellSectionId === 7);

  return (
    <div className={`item-upsells ${!isUpsellOnlyProctor ? 'mt-3 mt-sm-2' : ''}`}>
      {!isSingle && !isUpsellOnlyProctor && (
        <>
          <div className="mt-0">
            <button
              className={`btn-toggle upsell-toggle text-start align-items-start small fw-600 notranslate ${
                isUpsellCollapsed ? '' : 'is-expanded'
              }`}
              onClick={toggleCollapse}
            >
              {/* <span className="fs-5 lh-1 align-middle me-1">{isUpsellCollapsed ? <>&#43;</> : <>&#8722;</>} </span> */}
              <span className="align-middle">
                {isUpsellCollapsed ? (
                  <>
                    View<span className="d-none d-sm-inline">/Edit</span>
                  </>
                ) : (
                  'Hide'
                )}{' '}
                Course Upgrades & Add-ons
              </span>
            </button>
          </div>

          {isUpsellCollapsed && <SelectedUpsells item={item} />}
        </>
      )}

      <div
        className={`upsells-wrapper ${!isSingle && 'collapse'}`}
        // className={`upsells-wrapper mt-3 ${!isSingle && 'collapse'}`}
        // className={`upsells-wrapper mt-3`}
        ref={upsellCollapse}
        id={`upsells-collapse-${item.cart_ProductId}`}
      >
        <UpsellGroups item={item} />
      </div>

      {!isSingle && <UpsellProctor item={item} />}
    </div>
  );
}
